module.exports = __webpack_public_path__ + "static/img/pro5.2dbbb4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro5.png
// module id = NxbV
// module chunks = 0